import type { Haltestelle } from '@/model/haltestelle';
import { Identifikation } from '@/model/identifikation';

export type OmniItem = OmniBetriebsstelle | OmniHaltestelle | OmniTicket | OmniZug;

export enum OmniTyp {
  HALTESTELLE,
  BETRIEBSSTELLE,
  ZUG,
  TICKET,
}

export interface OmniBetriebsstelle {
  typ: OmniTyp.BETRIEBSSTELLE;
  name: string;
  rl100: string;
  betriebsstelleTyp: string | null;
}

export interface OmniHaltestelle {
  typ: OmniTyp.HALTESTELLE;
  name: string;
  evaNummer: string;
  rl100: string | null;
}

export interface OmniTicket {
  typ: OmniTyp.TICKET;
  name: string;
  ticketId: string;
}

export interface OmniZug {
  typ: OmniTyp.ZUG;
  reiseId: Identifikation;
  name: string;
  startHalt: string;
  zielHalt: string;
}

export function omnifyHaltestelle(haltestelle: Haltestelle): OmniHaltestelle {
  return {
    typ: OmniTyp.HALTESTELLE,
    name: haltestelle.name,
    evaNummer: haltestelle.evaNummer,
    rl100: haltestelle.rl100,
  };
}
